import styled from 'styled-components';

export const AppCardContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.5rem 2rem 2rem;
  position: relative;
  background: ${(props) => props.theme.neutralLighter};
  border-radius: 1rem;
  box-shadow: inset 0 6px 0 0 ${({ theme }) => theme.themePrimary},
    1px 1px 8px rgba(0, 0, 0, 0.2);

  cursor: pointer;
  transition: all 0.2s ease-in;

  &:hover {
    box-shadow: inset 0 10px 0 0 ${({ theme }) => theme.themePrimary},
      1px 1px 8px rgba(0, 0, 0, 0.4);
  }
`;
export const AppCardHeader = styled.div`
  display: grid;
  grid-template-columns: 3.75rem auto;
  column-gap: 1.25rem;

  .iconWrapper {
    grid-column: 1/2;
    grid-row: span 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3.75rem;
    width: 100%;
    border-radius: 1rem;
    background: ${({ theme }) => theme.themePrimary};
  }

  h1 {
    font: 700 1.2rem/1.2rem 'Roboto', sans-serif;
    align-self: end;
    grid-column: 2/3;
    grid-row: 1/2;
  }

  h2 {
    font: 200 0.9rem/.9rem 'Roboto', sans-serif;
    margin-top: 0.2rem;
    align-self: start;
    grid-column: 2/3;
    grid-row: 2/3;
  }
`;
export const AppCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  .skeletonWrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
  }

  p {
    font: 300 1.1rem/1.3rem 'Roboto', sans-serif;
  }
`;
export const AppCardTagContainer = styled.div`
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
`;
